$(document).ready(function() {
    var featureSlideOptions = {
        slidesToShow: 3,
        arrows: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    }
    var catItemsSlideOptions = {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    }
    $('.featureCarousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000
    });

    $('#featuredTabs .tabContent.active .featuredItems').slick(featureSlideOptions);

    $('#itemCategory .tabContent.active .catItems').slick(catItemsSlideOptions);




    //Tabs
    var featureCurrentTab = $('#featuredTabs .tabWrapper .tab.active')

    $('#featuredTabs .tabWrapper .tab').on('click', function(e) {
        var tab = $(this);
        if (tab.hasClass('active')) {return}

        // Remove Active
        featureCurrentTab.removeClass('active');
        $(featureCurrentTab.attr('data-tab')).removeClass('active')
        tab.addClass('active');
        featureCurrentTab = tab;
        $(tab.attr('data-tab')).addClass('active')
        var list = $(tab.attr('data-tab')).find('.featuredItems')
        if (list.hasClass('slick-initialized')) {return}


        list.slick(featureSlideOptions);

    })


    //Tabs
    var catCurrentTab = $('#itemCategory .tabWrapper .tab.active')
    $('#itemCategory .tabWrapper .tab').on('click', function(e) {
        var tab = $(this);
        if (tab.hasClass('active')) {return}

        // Remove Active
        catCurrentTab.removeClass('active');
        $(catCurrentTab.attr('data-tab')).removeClass('active');
        tab.addClass('active');
        catCurrentTab = tab;
        $(tab.attr('data-tab')).addClass('active')
        var list = $(tab.attr('data-tab')).find('.catItems')
        console.log(list);
        if (list.hasClass('slick-initialized')) {return}

        list.slick(catItemsSlideOptions);
    });
  
  	//Tabs
    var productCurrentTab = $('.productDetails .tabWrapper .tab.active')
    $('.productDetails .tabWrapper .tab').on('click', function(e) {
        var tab = $(this);
        if (tab.hasClass('active')) {return}

        // Remove Active
        productCurrentTab.removeClass('active');
        $(productCurrentTab.attr('data-tab')).removeClass('active');
        tab.addClass('active');
        productCurrentTab = tab;
        $(tab.attr('data-tab')).addClass('active')
       
    })
    var zoomConfig = {
        gallery: 'thumbSlider',
        zoomType: "lens",
        lensShape: "round",
        lensSize: 150,
        containLensZoom: true
    }

    var zoomImage = $('#zoomable')
    zoomImage.elevateZoom(zoomConfig);

    //Gallery Product

    $('.thumbSlider .thumbWrp').on('click', function(e) {
        var img = $(this).find('img').data('img-uri')
        $('.zoomContainer').remove();
        zoomImage.removeData('elevateZoom');
        zoomImage.attr('src', img);
        zoomImage.data('zoom-image', img);
        zoomImage.elevateZoom(zoomConfig);
    });

    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }


    function initProductAddToCart() {
        var addBox = $("#productForm .btnAddBox")

        addBox.click(function (e) {
            e.preventDefault();
            if ('disabled' != $(this).attr("disabled")) {

                var id = $("#productForm input[name=id]").val();
                var quantity = $("#productForm input[name=quantity]").val() || 1;
                var name = $(".productTitle h2").text(),
                    img = $("#zoomable").attr("src");
                ajaxAddToCart(id, quantity, name, img)
                return false;
            }

        })
    }
    initProductAddToCart();

    function initAddToCart() {
        $(".addCart").click(function(e) {
            e.preventDefault();
            var product = $(this).parents('.item'),
                id = $(this).data('id'),
                name = product.find('.itemName').text(),
                img = product.find('.itemImg img').attr('src');
            
            ajaxAddToCart(id, 1, name, img)
            return !1;
        })
    }

    initAddToCart();

    function showLoading() {
        $(".loader").show()
    }
    function hideLoading() {
        $(".loader").hide()
    }
    function updateCartCounter(count) {
        var currentCount = $('.navItem.box .counter').html();

        $('.navItem.box .counter').html(parseInt(currentCount) + parseInt(count));
    }
    function ajaxAddToCart(id, quantity, name, img) {

        $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: "quantity=" + quantity + "&id=" + id,
            dataType: "json",
            beforeSend: function() {
                showLoading()
            },
            success: function() {
                hideLoading();
                var modal = $('.modal.success');
                modal.find(".modalProductTitle").text(name);
                modal.find(".modalProductImg .productImage").attr("src", img);
                modal.find(".btn.btnCart").show();
                updateCartCounter(quantity);
                showModal(modal);
            },
            error: function(e) {
                hideLoading()
                var modal = $('.modal.fail');
                $(".errorMessage").text($.parseJSON(e.responseText).description)
                showModal(modal)
            }
        })
    }

    function showModal(modal) {
        modal.fadeIn(500),
            ellaTimeout = setTimeout(function() {
                modal.fadeOut(500)
            }, 5e3)
    }

    $('.modal .close, .modal .btnCancel').click(function(e) {
        $(this).parents('.modal').fadeOut(500);
    })
//Mobile Menu
    $('.toggler').click(function(e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.mainMobileMenu').removeClass('open');
            return
        }
        $(this).addClass('open');
        $('.mainMobileMenu').addClass('open');

    })
     //Mobile Search
    $('.mobileSearch').click(function(e) {
        e.preventDefault();
        if ($('.mobileSearchPop').hasClass('open')) {
            $('.mobileSearchPop').removeClass('open');

            return
        }

        $('.mobileSearchPop').addClass('open');

    });

    $('.mobileSearchPop .btnCancel').click(function(e) {
        $('.mobileSearchPop').removeClass('open');
    })
})